import { gql } from '@apollo/client';

export const NEW_VERSION_QUESTIONNAIRE = gql`
  mutation newVersionQuestionnaire($input: NewVersionQuestionnaire) {
    newVersionQuestionnaire(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DUPLICATE_QUESTIONNAIRE = gql`
  mutation duplicateQuestionnaire($input: DuplicateQuestionnaire) {
    duplicateQuestionnaire(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const EXPORT_QUESTIONNAIRES = gql`
  mutation exportQuestionnaires($input: QuestionnaireFilterMutationExportInput) {
    exportQuestionnaires(input: $input) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;
export const QUESTIONNAIRE_DELETE = gql`
  mutation questionnaireDelete($questionnaireId: Int!) {
    questionnaireDelete(questionnaireId: $questionnaireId) {
      commandId
      correlationId
    }
  }
`;

export const EVALUATE_QUESTIONNAIRE_FORMULA = gql`
  mutation evaluateQuestionnaireFormula($input: QuestionnaireSave) {
    evaluateQuestionnaireFormula(input: $input)
  }
`;

export const QUESTIONNAIRE_SAVE = gql`
  mutation questionnaire($input: QuestionnaireSave) {
    questionnaire(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const EVALUATE_QUESTION_FORMULA = gql`
  mutation evaluateQuestionFormula($input: QuestionSave) {
    evaluateQuestionFormula(input: $input)
  }
`;

export const QUESTION_SAVE = gql`
  mutation question($input: QuestionSave) {
    question(input: $input) {
      isSaved
      questionId
    }
  }
`;

export const QUESTION_DELETE = gql`
  mutation questionDelete($questionId: Int!) {
    questionDelete(questionId: $questionId) {
      commandId
      correlationId
    }
  }
`;

export const EVALUATE_QUESTION_ACTION_FORMULA = gql`
  mutation evaluateQuestionActionFormula($input: QuestionActionSave) {
    evaluateQuestionActionFormula(input: $input){
      error
      isOk
    }
  }
`;

export const QUESTIONACTION_SAVE = gql`
  mutation questionAction($input: QuestionActionSave) {
    questionAction(input: $input) {
      isSaved
      questionActionId
    }
  }
`;

export const QUESTIONACTION_DELETE = gql`
  mutation questionActionDelete($questionActionId: Int!) {
    questionActionDelete(questionActionId: $questionActionId) {
      commandId
      correlationId
    }
  }
`;
